import React, { useMemo, useState, useEffect } from 'react';
import { Modal, BlockStack, Card, Checkbox } from '@shopify/polaris';
import { useLockBodyScroll } from '../../../hooks/useLockBodyScroll';

export function ProductSettingsModal({ open, onClose, onSave, config }) {
  useLockBodyScroll(open);
  const initial = useMemo(() => ({
    treatKitsAsInventory: config?.treatKitsAsInventory !== undefined
      ? !!config.treatKitsAsInventory
      : true,  // default checked — treat kits as inventory items
    bundleDynamicSku: !!config?.bundleDynamicSku,
  }), [config]);

  const [local, setLocal] = useState(initial);
  useEffect(() => {
    if (open) setLocal(initial);
  }, [open, initial]);

  const handleSave = () => {
    onSave?.('products_settings', { ...local });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Product Settings"
      primaryAction={{ content: 'Save Configuration', onAction: handleSave }}
      secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
    >
      <Modal.Section>
        <BlockStack gap="loose">
          <Card sectioned>
            <BlockStack gap="loose">
              <Checkbox
                label="Treat kits / bundles as inventory items"
                helpText="When checked, NS kit items are synced as simple products. When unchecked, kits use platform-specific bundle handling (or are skipped if not configured)."
                checked={!!local.treatKitsAsInventory}
                onChange={(v) => setLocal((prev) => ({ ...prev, treatKitsAsInventory: !!v }))}
              />
              <Checkbox
                label="Bundle products use dynamic SKU"
                checked={!!local.bundleDynamicSku}
                onChange={(v) => setLocal((prev) => ({ ...prev, bundleDynamicSku: !!v }))}
              />
            </BlockStack>
          </Card>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
